(function () {
  'use strict';

  function initSparesCards() {
    document.querySelectorAll('[data-spares-card]:not([data-spares-card-initialized])').forEach(function (card) {
      card.setAttribute('data-spares-card-initialized', '');

      var jsonEl = card.querySelector('[data-spares-card-variants]');
      if (!jsonEl) return;

      var variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (error) {
        return;
      }

      if (!variants.length) return;

      var prevBtn = card.querySelector('[data-spares-card-prev]');
      var nextBtn = card.querySelector('[data-spares-card-next]');
      var image = card.querySelector('[data-spares-card-image], .rabitat-spares-card__image:not(.rabitat-spares-card__image--placeholder)');
      var mediaLink = card.querySelector('.rabitat-spares-card__media');
      var variantName = card.querySelector('[data-spares-card-variant-name]');
      var priceEl = card.querySelector('[data-spares-card-price]');
      var addBtn = card.querySelector('[data-spares-card-add]');
      var addLabel = addBtn ? addBtn.dataset.sparesAddLabel || 'Add to Cart' : 'Add to Cart';
      var soldOutLabel = addBtn ? addBtn.dataset.sparesSoldOutLabel || 'Sold out' : 'Sold out';
      var initialVariantId = addBtn ? addBtn.getAttribute('data-variant-id') : null;
      var current = Math.max(
        0,
        variants.findIndex(function (variant) {
          return String(variant.id) === String(initialVariantId);
        })
      );

      function render(index) {
        var variant = variants[index];
        if (!variant) return;

        if (image && variant.image) {
          image.src = variant.image;
          image.removeAttribute('srcset');
          image.alt = variant.name || image.alt || (mediaLink && mediaLink.getAttribute('aria-label')) || '';
        }

        if (variantName && !card.querySelector('[data-spares-card-description]')) {
          variantName.textContent = variant.name;
        }

        if (priceEl) {
          priceEl.innerHTML = variant.price_formatted;
        }

        if (addBtn) {
          addBtn.setAttribute('data-variant-id', variant.id);
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? addLabel : soldOutLabel;
        }
      }

      function show(index) {
        current = (index + variants.length) % variants.length;
        render(current);
      }

      if (variants.length <= 1) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        render(current);
        return;
      }

      render(current);

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          show(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          show(current + 1);
        });
      }
    });
  }

  function initSparesAddToCart() {
    document.querySelectorAll('[data-spares-card-add]').forEach(function (button) {
      if (button.dataset.sparesAddBound === 'true') return;
      button.dataset.sparesAddBound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (button.disabled) return;

        var variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;

        button.disabled = true;

        var addPayload = { id: variantId, quantity: 1 };

        if (window.RabitatCart && typeof window.RabitatCart.withCartSections === 'function') {
          addPayload = window.RabitatCart.withCartSections(addPayload);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(addPayload)
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (lineItem) {
            if (window.RabitatCart && typeof window.RabitatCart.syncCartAfterAdd === 'function') {
              window.RabitatCart.syncCartAfterAdd(lineItem);
            } else {
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }
          })
          .catch(function () {
            alert('Unable to add to cart. Please try again.');
          })
          .finally(function () {
            var variantId = button.getAttribute('data-variant-id');
            var card = button.closest('[data-spares-card]');
            var jsonEl = card ? card.querySelector('[data-spares-card-variants]') : null;
            var isAvailable = true;

            if (jsonEl) {
              try {
                var cardVariants = JSON.parse(jsonEl.textContent);
                var activeVariant = cardVariants.find(function (variant) {
                  return String(variant.id) === String(variantId);
                });
                isAvailable = activeVariant ? activeVariant.available : true;
              } catch (error) {
                isAvailable = true;
              }
            }

            button.disabled = !isAvailable;
            button.textContent = isAvailable
              ? button.dataset.sparesAddLabel || 'Add to Cart'
              : button.dataset.sparesSoldOutLabel || 'Sold out';
          });
      });
    });
  }

  function initSparesCarousel() {
    document.querySelectorAll('[data-spares-carousel]').forEach(function (carousel) {
      if (carousel.dataset.sparesCarouselBound === 'true') return;
      carousel.dataset.sparesCarouselBound = 'true';

      var viewport = carousel.querySelector('[data-spares-viewport]');
      var track = carousel.querySelector('[data-spares-track]');
      var prevBtn = carousel.querySelector('[data-spares-prev]');
      var nextBtn = carousel.querySelector('[data-spares-next]');
      if (!viewport || !track) return;

      function scrollByCard(direction) {
        var card = track.querySelector('.rabitat-spares-card');
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap || 0) || 0;
        var amount = direction * (card.offsetWidth + gap);
        if (typeof viewport.scrollBy === 'function') {
          viewport.scrollBy({ left: amount, behavior: 'smooth' });
        } else {
          viewport.scrollLeft += amount;
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByCard(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByCard(1);
        });
      }
    });
  }

  function initAll() {
    initSparesCards();
    initSparesAddToCart();
    initSparesCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
